import {React,useState} from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import PermIdentityRoundedIcon from "@mui/icons-material/PermIdentityRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchBar from "../../search/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { sidebarActions } from "../../../store/SidebarSlice";
import Logo from "../../../assets/logo/RPJ.png";
import "./navbar.css";

function Navbar() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };
  console.log(isOpen);
  const handleSidebar = () => {
    dispatch(sidebarActions.togglesidebar());
  };
  const cartItems = JSON.parse(localStorage.getItem("incart")) || [];
  const cartItemCount = cartItems.length;

  return (
    <AppBar position="static" color="default">
      <Toolbar className="nav">
        {isMobile && (
          <IconButton edge="start" color="inherit" onClick={handleSidebar}>
            {isOpen ? <CloseIcon onClick={toggleOpen} sx={{ fontSize: "2rem", color: "#cb835b" }} /> : <MenuIcon onClick={toggleOpen} sx={{ fontSize: "2rem", color: "#cb835b" }} />}
          </IconButton>
        )}
        <Link to="/">
          <img src={Logo} alt="Logo" className="logo" />
        </Link>

        {isDesktop && <SearchBar />}

        <div className="navicons">
          <IconButton aria-label="profile" color="inherit">
            <PermIdentityRoundedIcon
              sx={{ fontSize: "2vh", color: "#cb835b" }}
            />
          </IconButton>
          <IconButton aria-label="favorites" color="inherit">
            <FavoriteBorderRoundedIcon
              sx={{ fontSize: "2vh", color: "#cb835b" }}
            />
          </IconButton>
          <IconButton
            aria-label="cart"
            color="inherit"
            component={Link}
            to="/cart"
          >
            <Badge
              badgeContent={cartItemCount > 0 ? cartItemCount : 0}
              color="error"
            >
              <AddShoppingCartIcon sx={{ fontSize: "2vh", color: "#cb835b" }} />
            </Badge>
          </IconButton>
          <IconButton></IconButton>
        </div>
      </Toolbar>
      
      {!isDesktop && <SearchBar />}
    </AppBar>
  );
}

export default Navbar;
